import React from 'react';
import { Modal } from '@zurich-base-ui/components.modal';
import { Button } from '@zurich-primitives/button';
import styles from './AskYourDocsInstructions.module.scss';

export interface IAskYourDocsInstructions {
  isOpen: boolean;
  onClose: () => void;
}

export const AskYourDocsInstructions: React.FC<IAskYourDocsInstructions> = ({
  isOpen,
  onClose
}) => {
  return (
    <Modal on={isOpen} onClose={onClose} variant="slim">
      <div className={styles.modal}>
        <h2>How to Use Ask Your Docs</h2>

        <div className={styles.content}>
          <div className={styles.section}>
            <h3>1. Upload documents</h3>
            <p>
              To upload your first document, use the{' '}
              <span style={{ color: '#0F67BF', fontWeight: 500 }}>···</span>{' '}
              menu in the{' '}
              <span style={{ color: '#0F67BF', fontWeight: 500 }}>
                Documents
              </span>{' '}
              section. Supported formats: .pdf, .docx, .pptx, .msg
            </p>
          </div>

          <div className={styles.section}>
            <h3>2. Start chatting with your document(s)</h3>
            <p>
              Click{' '}
              <span style={{ color: '#0F67BF', fontWeight: 500 }}>
                New Chat
              </span>{' '}
              first, then select the document(s) you want to use, and start
              typing your question.
            </p>
          </div>

          <div className={styles.section}>
            <h3>3. Manage your data</h3>
            <p>
              You can manage chats and documents using their{' '}
              <span style={{ color: '#0F67BF', fontWeight: 500 }}>···</span>{' '}
              menus.
            </p>
            <p>
              Your documents are stored securely for persistent use. Delete them
              when your session is complete if you don&apos;t want them stored.
            </p>
          </div>
        </div>

        <Button
          variant="primary"
          onClick={onClose}
          className={styles['close-btn']}
        >
          <Button.Label>Got it!</Button.Label>
        </Button>
      </div>
    </Modal>
  );
};
